<template>
    <transition name="slide">
        <div class="side-menu-container">
            <div :class="['side-menu', navbarHidden ? 'navbar-hidden' : '', showHiddenNav ? 'show-hidden-nav' : '']" ref="menu">
                <div class="sidemenu-content">
                    <div class="sidemenu-items">
                        <div class="sidemenu-item">
                            <a ref="navBoardIcon" class="nav-board-icon" href="#" @click.prevent="openMainMenu">
                                <i class="icon-app"></i>
                            </a>
                            <div v-if="showBoardsPopup" class="board-popup-container">
                                <div class="board-popup-inner">
                                    <div class="board-popup-header">
                                        <div class="board-popup-title">Projects</div>
                                        <!-- <VCheckboxToggle
                                            v-if="boards.length > 1"
                                            :model="order_projects"
                                            @changeHandler="(val) => order_projects = val"
                                            checkboxLabel="Order"
                                        /> -->

                                        <CustomCheckbox
                                            v-if="boards.length > 1"
                                            :value="order_projects"
                                            @input="(val) => this.order_projects = val"
                                            checkboxLabel="Order"
                                        />
                                    </div>
                                    <div class="boards-container">
                                        <div class="board-items">
                                            <div
                                                v-for="board in boards"
                                                :key="board.id"
                                                @click.prevent="goToBoard(board)"
                                                :class="['board-item', 'hide-menu-link', board.id == Number($route.params.board_id) && ($route.name == 'Project' || $route.name == 'TaskModal') ? 'board-item-active' : '']"
                                            >
                                                {{ board?.title }}
                                                <div class="board-item-funcs">
                                                    <span class="board-item-notif" v-if="board?.notif_count">{{  board?.notif_count }}</span>
                                                    <VButton v-if="boards && boards.length > 1 && order_projects" class="switch-board-btn" :stop="true" @clickHandler="switchWithBottom(board)">
                                                        <i class="icon-chevron-down"></i>
                                                    </VButton>
                                                    <VButton v-if="boards && boards.length > 1 && order_projects" class="switch-board-btn" :stop="true" @clickHandler="switchWithTop(board)">
                                                        <i class="icon-chevron-up"></i>
                                                    </VButton>
                                                    <a href="#" @click.prevent="showBoardDropmenuPopup($event, board.id)">
                                                        <i class="icon-dots-horizontal-triple" style="color: #fff;"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="#" @click.prevent="openNewBoard" class="add-board hide-menu-link">
                                            <i class="icon-add"></i>
                                        </a>
                                    </div>
                                    <div class="board-popup-title">Apps</div>
                                    <div class="apps-container">
                                        <router-link :to="`/smart-board/${activeBoard?.id}`" class="app-item hide-menu-link">
                                            <img src="@/assets/images/smart-list.svg" alt="">
                                            <p>Smart Board</p>
                                        </router-link>

                                        <router-link :to="`/timetable/${activeBoard?.id}`" class="app-item hide-menu-link">
                                            <img src="@/assets/images/time.svg" alt="">
                                            <p>Time</p>
                                        </router-link>
                                        
                                        <router-link to="/all-activities" class="app-item hide-menu-link">
                                            <img src="@/assets/images/activities-icon.svg" alt="">
                                            <p>Activities</p>
                                        </router-link>
                                    </div>
                                    <div class="side-menu-divider"></div>
                                    <div class="board-popup-title">Settings</div>
                                    <div class="apps-container">
                                        <a href="#" @click.prevent="$refs['profile-modal'].showModal()" class="app-item hide-menu-link">
                                            <img src="@/assets/images/profile.svg" alt="">
                                            <p>Profile</p>
                                        </a>

                                        <a href="#" @click.prevent="$refs['billing-modal'].showModal()" class="app-item hide-menu-link">
                                            <img src="@/assets/images/Billing.svg" alt="">
                                            <p>Billing</p>
                                        </a>

                                        <a href="#" @click.prevent="openEmailNotifsModal()" class="app-item hide-menu-link">
                                            <img src="@/assets/images/notifications.svg" alt="">
                                            <p>Notifications</p>
                                        </a>
                                    
                                        <a href="#" @click.prevent="$refs['theme-modal'].showModal()" class="app-item hide-menu-link">
                                            <img src="@/assets/images/themes.svg" alt="">
                                            <p>Themes</p>
                                        </a>

                                        <a href="#" @click.prevent="$refs['version-modal'].showModal()" class="app-item hide-menu-link">
                                            <img src="@/assets/images/version.svg" alt="">
                                            <p>Version</p>
                                        </a>

                                    </div>
                                </div>

                                <CustomCheckbox
                                    :value="hideNavbar"
                                    @input="hideNavbarFunc"
                                    checkboxLabel="Auto-hide Navbar"
                                    ref="hideModalRef"
                                    class="hideModalRef"
                                />

                            </div>
                        </div>
                        <div class="sidemenu-item board-title">
                            <h3 v-html="currentRouteTitle()"></h3>
                        </div>
                        <ProjectTagFilter
                            @setFilterUserTags="setFilterUserTags"
                            @setFilterTags="setFilterTags"
                            @setFilterSmartTags="setFilterSmartTags"
                            @setFilterSmartUsers="setFilterSmartUsers"
                            @setSmartAvatarDropdownVisible="setSmartAvatarDropdownVisible"
                            @setAvatarDropdownVisible="setAvatarDropdownVisible"
                            @setDropdownVisible="setDropdownVisible"
                            :isDropdownVisible="isDropdownVisible"
                            :visibleUsers="visibleUsers"
                            :isAvatarDropdownVisible="isAvatarDropdownVisible"
                            :isSmartAvatarDropdownVisible="isSmartAvatarDropdownVisible"
                            :visibleUserTags="visibleUserTags"
                            :dropdownUserTags="dropdownUserTags"
                            :dropdownUsers="dropdownUsers"
                            :dropdownTags="dropdownTags"
                            :visibleTags="visibleTags"
                        />
                        <label v-if="$route.name == 'Project'" class="custom-input-file">
                            <input type="file" accept=".csv" @input="importCSV">
                            <span class="fake-btn">
                                Import tasks
                                <i class="icon-question-mark" @click="downloadExample">
                                    <Tooltip>
                                        <div class="tooltip__info">
                                            <p>Import multiple tasks with our tool. <br>Please download <span style="color: #4E8EF8">example CSV</span> to see <br> how to structure the data.</p>
                                            <VButton @clickHandler="() => {}" active class="flow-btn">Download</VButton>
                                        </div>
                                    </Tooltip>
                                </i>
                            </span>
                        </label>
                        <router-link v-if="$route.name !== 'Project'" :to="`/project/${activeBoard && activeBoard['id']}`" class="nav-btn hide-menu-link"
                        >
                            <i class="icon-back"></i>
                             Back
                        </router-link>
                    </div>
                    <div v-if="$route.name == 'Activities'" class="show-info-btn-wrapper" @click="toggleInfoModal()">
                        <span>What is this</span>
                        <i class="icon-question-mark"></i>
                    </div>
                </div>
            </div>
            <a href="#" ref="aloneBtn" :class="['alone-board-icon', !navbarHidden ? 'hide-alone-icon': '']" @click.prevent="showBoardsPopup = !showBoardsPopup, showHiddenNav = true">
                <img src="@/assets/images/boards-icon.svg" alt="">
            </a>
            <!-- Why the screencast component is here, while it supposed to be in the edit task? -->
            <ScreenCast />

            <div
                v-if="showBoardDropmenuOptions"
                class="list_pop_up md boardDropmenu"
                ref="board-dropmenu"
            >
                <ul class="dropmenu-list">
                    <li>
                        <a 
                            href="#" @click.prevent="openEditProjectModal()"
                            class="hide-menu-link"
                        >
                            <i class="icon-edit-small"></i>
                            <span>Edit</span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="goToMembers()" class="hide-menu-link">
                            <i class="icon-members-small"></i>
                            <span>Members</span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="goToAPIKeys()" class="hide-menu-link">
                            <i class="icon-api-small"></i>
                            <span>API Keys</span>
                        </a> 
                    </li>
                </ul>
            </div>

            <VModal
                :title="newProjectStep == 1 ? 'New Project' : currentProjectCreating || 'New Project'"
                ref="new-board"
                :flexheight="true"
                size="md"
                @hideModal="newProjectModalHidden"
                :class="['new-project-flow-modal', newProjectStep == 2 ? 'step2' : '']"
            >
                <div v-if="newProjectStep == 1">
                    <p>Project type</p>
                    <div class="bg-description mg-btt-24">This just indicate your starting point. <br> You can customize your board as you like afterwards.</div>
                    <div class="project-types">
                        <a v-for="projectType in projectTypes" href="#" @click.prevent="chooseProjectType(projectType)" class="project-type-card">{{ projectType.title }}</a>
                    </div>
                    <div v-if="clonableProjects.length">
                        <p class="mg-10-0">Clone your projects</p>
                        <div class="project-types mg-btt-15">
                            <a v-for="project in clonableProjects" href="#" @click.prevent="chooseProjectType(project, true)" class="project-type-card clone-project">{{ project.title }}</a>
                        </div>
                    </div>
                </div>
                <div v-if="newProjectStep == 2">
                    <label for="board-new-name">Project Title</label>
                    <Textfield
                        id="board-new-name"
                        ref="createProjectTitleRef"
                        v-model="board.title"
                        :placeholder="'Project name'"
                        :maxlength= 30
                        class="new-project-textfield"
                    />
                    <CustomCheckbox
                        v-if="cloningProject"
                        :value="clone_tasks"
                        @input="(val) => this.clone_tasks = val"
                        checkboxLabel="Clone tasks"
                    />
                    <p class="mg-10-0">Members</p>
                    <label class="bg-description mg-btt-15">Invite New Member (Type User name or Email)</label>
                    <div class="input-tags-wrap">
                        <div class="tags mb-3">
                            <div class="wrap-tag">
                                <!-- Here base url of the currentUser portrait property gets removed because we also add the baseURL in the useravar component and we add baseURL to currentUser in the store -->
                                <UserAvatar :user="{...currentUser, portrait: currentUser.portrait.replace(this.baseURL, '')}" size="medium"></UserAvatar>
                                <span>Owner(Me)</span>
                            </div>
                            <div
                                v-for="(item, index) in newProjectMembers"
                                :key="item.id"
                                class="wrap-tag"
                            >
                                <UserAvatar
                                    :user="item"
                                    size="medium"
                                ></UserAvatar>
                                <span>{{ item.username }}</span>
                                <span class="delete-tag" @click.prevent="removeUserFromNewProject(index)"></span>
                            </div>

                            <div 
                                class="tags-search-filter__btn"
                                @click="onTagsPlusClick()"
                            >
                                +
                            </div>
                            <div class="relative-container">
                                <div class="dropdown" v-if="isTagInputFocused">
                                    <input
                                        ref="searchInput"
                                        v-model="searchUser"
                                        type="text"
                                        class="text-input"
                                        placeholder="Search..."
                                        @blur="clearTagSearch()"
                                        @focus="isTagInputFocused = true"
                                        @input="searchNewProjectUser()"
                                    />
                
                                    <div v-if="searchUser.trim().length == 0">
                                        <div class="flex-gap-9 dropdown-item" v-for="item in smartListUsersEXCLUDEME" @click="addUserToNewProject({
                                            username: item.username,
                                            portrait: item.portrait,
                                            name: item.name,
                                            id: item.id
                                        })">
                                            <UserAvatar
                                                :user="item"
                                                size="medium"
                                            ></UserAvatar>
                                            <p class="tags-username">
                                                {{ item['username'] }}
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else-if="loadingMembers">
                                        <div class="flex-gap-9">
                                            <p class="tags-username">Loading members...</p>
                                        </div>
                                    </div>
                                    <div v-else-if="apiUsersSearchResult.length > 0">
                                        <div class="flex-gap-9 dropdown-item" v-for="item in apiUsersSearchResult" @click="addUserToNewProject(item)">
                                            <UserAvatar
                                                :user="item"
                                                size="medium"
                                            ></UserAvatar>
                                            <p class="tags-username">
                                                {{ item['username'] }}
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else-if="apiUsersSearchResult.length == 0">
                                        <p class="tags-username user-dont-exist-msg">User doesn't exist. Click on it to create and invite to the project.</p>
                                        <div @click="openInviteUserModal">
                                            <p class="wrap-tag flex-gap-9 dropdown-item">{{ this.searchUser }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-btwn">
                        <VButton
                            @clickHandler="newProjectStep = 1"
                            class="flow-btn"
                        >Back</VButton>
                        <VButton
                            @clickHandler="createBoard"
                            :disabled="creatingNewProject"
                            class="flow-btn"
                            active
                        >Create</VButton>
                    </div>
                </div>
            </VModal>
            <VModal title="Invite New Member" ref="invite-user-new-project" class="new-project-flow-modal" size="sm" :flexheight="true">
                <label class="bg-description mg-btt-15">This user is not a Goleko member. Please fill in the fields and press “Invite”.</label>
                <label for="invite-user-name">Name of member</label>
                <Textfield
                    id="invite-user-name"
                    ref="inviteUserNameRef"
                    v-model="currentUserWhoDontExist.name"
                    :placeholder="'Name'"
                    @keydownenter="inviteUserToNewProject"
                    class="new-project-textfield"
                />
                <label for="invite-user-username">Username</label>
                <Textfield
                    id="invite-user-username"
                    v-model="currentUserWhoDontExist.username"
                    @keydown="handleInput"
                    @paste="handlePaste"
                    @keydownenter="inviteUserToNewProject"
                    :placeholder="'Username'"
                    class="new-project-textfield"
                />
                <VButton
                    @clickHandler="inviteUserToNewProject"
                    class="flow-btn"
                    active
                >Invite</VButton>
                <VButton
                    @clickHandler="cancelUserInvitation"
                    class="flow-btn"
                    style="margin-left: 10px"
                >Cancel</VButton>
            </VModal>
            <VModal title="Themes" ref="theme-modal" class="theme-modal" size="sm" :flexheight="true">
                <div class="themes-container">
                    <div v-for="(theme, i) in themes" :key="i" class="theme-item">
                        <p>{{ theme.title }}</p>
                        <input type="radio" :value="theme.name" :id="theme.name" name="theme" :checked="mainTheme == theme.name" @change="changeTheme(theme.name)">
                        <label :for="theme.name" :style="theme.styles"></label>
                    </div>
                </div>
            </VModal>
            <VModal title="Version" ref="version-modal" size="md " :flexheight="true" class="version">
                <div class="help-text">
                    This is purely for debugging purposes.
                    If you have a bug report, please also copy this one here so we can see what version you use.
                </div>
                <div>
                    <p>Branch: <strong>{{ version.branch }}</strong></p>
                    <p>Commit: <strong>{{ version.commit }}</strong></p>
                    <p>Date: <strong>{{ version.date }}</strong></p>
                    <p>User: <strong>{{ version.user }}</strong></p>
                </div>
            </VModal>
            <VModal class="edit-board" ref="edit-board" size="sm" :flexheight="true">
                <!-- <div class="edit-board-head">
                    <div class="portrait-container">
                        <img v-if="currentUser?.portrait" :src="currentUser.portrait">
                        <p class="initial" v-else>{{ firstLetterUsername(currentUser?.username) }}</p>
                    </div>
                    <div v-if="showInProgress" class="in-progress">In Progress...</div>
                    <div class="pfp-uploader">
                        <VButton @clickHandler="toggleInProgress">Upload</VButton>
                    </div>
                </div> -->
                <div class="edit-board-body">
                    <h3>Project Name</h3>
                    <form @submit.prevent="editProject({title: editedBoardName})">
                        <Textfield v-model="editedBoardName" :placeholder="'Project Name'" />
                        <h3>Background Color</h3>
                        <BackgroundSwitcher @color-selected="val => editProject({color: val.styles})" />

                        <VButton
                            @clickHandler="val => editProject({title: editedBoardName})"
                            active
                        >Save</VButton>
                        <VButton
                            @clickHandler="$refs['edit-board'].hideModal()"
                        >Cancel</VButton>
                    </form>
                </div>
                <div class="delete-btn-wrap" v-if="activeBoard && activeBoard.yourPerms.includes('admin')">
                    <VButton 
                        @clickHandler="$refs['confirm-delete-board'].$refs['confirm-delete-board'].showModal()"
                        theme="orange"
                        active
                        >Delete</VButton>
                </div>
            </VModal>

            <VModal title="Notifications" ref="email-notifs" :flexheight="true" class="email-notifs">
                <div class="bg-description">
                    <p>You can customize your notifications per project. Choose between 3 options:<br>
                        Daily Emails, Instant Emails and turn off.</p>
                </div>
                <div v-if="loadingEmailNotifs">Loading...</div>
                <div class="email-notifs-table" v-else>
                    <table>
                        <thead>
                            <th>Project</th>
                            <th>Time registration</th>
                            <th>Comments</th>
                            <th>Assigned</th>
                        </thead>
                        <tbody>
                            <tr v-for="project in this.emailNotifs">
                                <td class="email-notifs__project-title">{{ project?.title }}</td>
                                <td >
                                    <div class="email-notifs__selector">
    
                                        <VSelect 
                                            :options="emailNotifsOptions"
                                            value="id"
                                            title="title"
                                            :setDefaultValue="project.notif_time_reg"
                                            @selectHandler="(val) => selectEmailNotifsOption(project, val, 'notif_time_reg')"
                                        />
                                        <i class="icon-arrow-down-small"></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="email-notifs__selector">
                                        <VSelect 
                                            :options="emailNotifsOptions"
                                            value="id"
                                            title="title"
                                            :setDefaultValue="project.notif_comments"
                                            @selectHandler="(val) => selectEmailNotifsOption(project, val, 'notif_comments')"
                                        />
                                        <i class="icon-arrow-down-small"></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="email-notifs__selector">
                                        <VSelect 
                                            :options="emailNotifsOptions"
                                            value="id"
                                            title="title"
                                            :setDefaultValue="project.notif_assignments"
                                            @selectHandler="(val) => selectEmailNotifsOption(project, val, 'notif_assignments')"
                                        />
                                        <i class="icon-arrow-down-small"></i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </VModal>

            <VModal ref="profile-modal" class="profile-modal" size="md" :flexheight="true">
                <MyProfile @show-logout-modal="() => $refs['confirm-logout-board'].showModal()"
                           @user-data-saved="() => $refs.show.showFlashSuccess(`User info updated successfully!`)"
                />
            </VModal>

            <VModal ref="billing-modal" class="billing-modal" size="md" :flexheight="true">
                <Billing />
            </VModal>

            <VModal ref="confirm-logout-board" size="sm" :flexheight="true" style="z-index: 100;">
                <div class="text-center">
                    <p>Are you sure?</p>
                </div>
                <div class="btn-holder">
                    <VButton @clickHandler="logOut">Yes</VButton>
                    <VButton @clickHandler="$refs['confirm-logout-board'].hideModal()">No</VButton>
                </div>
            </VModal>

            <ConfirmDelete
                ref="confirm-delete-board"
                id="confirm-delete-board"
                title="board"
                @delete="deleteBoard"
            />
            <Flash ref="show"/>
        </div>
    </transition>
</template>

<script>
import VButton from "@/components/atoms/VButton.vue";
import VSelect from "@/components/atoms/VSelect.vue";
import VButtonClose from "@/components/atoms/VButtonClose.vue";
import { mapState } from 'vuex';
import {api} from "@/mixins/axios";
import {baseURL} from "@/mixins/helpers";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import VModal from "@/components/atoms/VModal.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import Flash from "@/components/Flash.vue";
import VCheckboxToggle from "@/components/atoms/VCheckboxToggle.vue";
import CustomCheckbox from "@/components/atoms/CustomCheckbox.vue";
import Tooltip from "@/components/atoms/Tooltip.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";
import UserAvatar from "@/components/atoms/UserAvatar.vue";
import ColorSelector from "@/components/atoms/ColorSelector.vue";
import ScreenCast from "@/components/organism/ScreenCast.vue";
import ProjectTagFilter from "@/components/molecules/ProjectTagFilter.vue";
import MyProfile from "@/components/molecules/MyProfile.vue";
import Billing from "@/components/molecules/Billing.vue";
import BackgroundSwitcher from "@/components/atoms/BackgroundSwitcher.vue";
import EventsTabs from "@/components/molecules/EventsTabs.vue";

export default {
	components: {
        VButton,
		VButtonClose,
        ConfirmDelete,
        VModal,
        Textfield,
        Dropmenu,
        Flash,
        VCheckboxToggle,
        VSelect,
        Tooltip,
        Dropdown,
        UserAvatar,
        ColorSelector,
        ScreenCast,
        ProjectTagFilter,
        BackgroundSwitcher,
        MyProfile,
        Billing,
        CustomCheckbox,
        EventsTabs
	},
    props: {
        title: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },
    props: ["boardOverviewFunc", 'listItem', 'extendedList', 'list', 'listIndex'],
    data() {
        return {
            menuVisible: this.show,
            board: {},
            showBoards: true,
            showSideFilter: false,
            showMembers: false,
            userTags: [],
            member: {
                email: "",
                role: "member",
                project: "",
            },
            task: [],
            events: [],
            openBoardOptions: false,
            editedBoardName: '',
            editedEmail: '',
            showBoardsPopup: false,
            showBoardDropmenuOptions: false,
            hideNavbar: false,
            navbarHidden: false,
            showHiddenNav: false,
            deleteId: '',
            smartListUsers: [],
            order_projects: false,
            projectTypes: [
                {title: 'To Do List ', id: 95},
                {title: 'Kanban', id: 87},
                {title: 'Customer Support', id: 88},
            ],
            currentProjectCreating: 'To Do List',
            currentProjectCreatingId: '',
            newProjectStep: 1,
            showInProgress: false,
            updateNavbarFlag: false,
            version: aboutUs,
            isListOpened: false,
            board_id_from_dropmenu: '',
            dropmenuOptionClicked: false,
            sidemenu_board_id: null,
            clonableProjects: [],
            searchUser: '',
            isTagInputFocused: false,
            isInputFocused: false,
            newProjectMembers: [],
            apiUsersSearchResult: [],
            cacheTimer: null,
            loadingMembers: false,
            smartListUsersEXCLUDEME: [],
            visibleUsers: [],
            visibleUserTags: [],
            visibleTags: [],
            dropdownTags: [],
            dropdownUserTags: [],
            dropdownUsers: [],
            isAvatarDropdownVisible: false,
            isSmartAvatarDropdownVisible: false,
            isDropdownVisible: false,
            windowWidth: window.innerWidth,
            baseURL: baseURL(),
            currentUserWhoDontExist: {
                name: '',
                username: '',
                email: ''
            },
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            creatingNewProject: false,
            u_searchQuery: '',
            emailNotifs: [],
            loadingEmailNotifs: false,
            emailNotifsOptions: [{
                title: 'Daily',
                id: 'email_daily'
            }, {
            //     title: 'Instant',
            //     id: 'email_instant'
            // }, {
                title: 'Off',
                id: 'off'
            }],
            newProjectColor: null,
            cloningProject: false,
            clone_tasks: true
        };
    },
    computed:{
        boards() {
            return this.$store.getters.boards
        },
        members() {
            return this.$store.getters.members
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        users() {
            return this.$store.getters.users
        },
        ...mapState(['smartListFilter']),
        tags() {
            return this.$store.getters.tags
        },
		mainTheme() {
			return this.$store.getters.theme
		},
		themes() {
			return this.$store.getters.themes
		},
		events2() {
			return this.$store.getters.events2
		},
        activitiesSelectedBoard() {
			return this.$store.getters.activitiesSelectedBoard
        }
    },
    methods: {
        toggleInfoModal() {
            document.querySelector('.show-info-btn').click()
        },
        toggleListOptionsPopUp() {
            this.$emit('toggleListOptionsPopUp', this.listItem, this.listIndex, this.boardIndex)
        },
        openEditModal(modalId) {
            this.$emit('openEditModal', modalId)
        },
        toggleInProgress() {
            this.showInProgress = !this.showInProgress;
        },
        addUserToNewProject(item) {
            const exists = this.newProjectMembers.some(obj => obj.username === item.username);
            if(!exists) {
                this.newProjectMembers.push(item)
            }
        },
        async inviteUserToNewProject() {
            if (this.currentUserWhoDontExist.name.trim() == '' ||
                this.currentUserWhoDontExist.username.trim() == '' ||
                this.currentUserWhoDontExist.email.trim() == ''
            ) {
                this.$refs.show.showFlashError("Empty field");
                return
            }

            if (!this.reg.test(this.currentUserWhoDontExist.email)) {
                this.$refs.show.showFlashError("Invalid Email Address");
                return
            }

            try {
                const response = await api.post('/user_invite', this.currentUserWhoDontExist)
                if (response.data.msg == 'ok') {
                    this.newProjectMembers.push({...response.data.data})
                    this.cancelUserInvitation()
                }
            } catch(e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || `Couldn't invite user`)
            }
        },
        handleInput(_, event) {
            if (event.key == ' ') event.preventDefault()
        },
        handlePaste(event) {
            setTimeout(() => this.currentUserWhoDontExist.username = event.target.value.replace(/\s/g, ''), 10)
        },
        openInviteUserModal() {
            if (!this.reg.test(this.searchUser)) {
                this.$refs.show.showFlashError("Invalid Email Address");
                return
            }

            this.$refs['invite-user-new-project'].showModal()
            this.currentUserWhoDontExist.email = this.searchUser
            this.$nextTick(() => this.$refs.inviteUserNameRef.$el.querySelector('input').focus())
        },
        cancelUserInvitation() {
            this.currentUserWhoDontExist = {
                name: '',
                username: '',
                email: ''
            }
            this.$refs['invite-user-new-project'].hideModal()
        },
        removeUserFromNewProject(index) {
            this.newProjectMembers.splice(index, 1)
        },
        searchNewProjectUser() {
            this.loadingMembers = true
            clearTimeout(this.cacheTimer)
            this.cacheTimer = setTimeout(async () => {
                try {
                    const data = {
                        q: this.searchUser,
                        paginate_by: 5
                    }
                    const response = await api.post(`/user_search`, data);
                    if (response.data.msg == 'ok') {
                        this.loadingMembers = false
                        this.apiUsersSearchResult = response.data.data.filter(user => user.id !== this.currentUser.id)
                    }

                } catch (e) {
                    this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message)
                }
            }, 500)
        },
        openMainMenu() {
            this.showBoardsPopup = !this.showBoardsPopup

            if (!this.showBoardsPopup) return
            
            this.$nextTick(() => {
                const hideNavbarLS = JSON.parse(localStorage.getItem('hideNavbar')) || false
                this.$refs.hideModalRef.$el.querySelector('input').checked = hideNavbarLS
            })
        },
        showBoardDropmenuPopup(event, boardID) {
            event.stopPropagation();
            this.showBoardDropmenuOptions = true
            this.board_id_from_dropmenu = boardID
            this.$nextTick(() => this.setBoardDropmenuPosition(event))
        },
        setBoardDropmenuPosition(event) {
            if(!this.$refs['board-dropmenu']) return

            const buttonRect = event.target.getBoundingClientRect()
            const dropmenuRect = this.$refs['board-dropmenu'].getBoundingClientRect()

            this.$refs['board-dropmenu'].style.left = buttonRect.left + buttonRect.width - dropmenuRect.width + 'px';
            this.$refs['board-dropmenu'].style.top = buttonRect.bottom + 'px';
        },
        openEditProjectModal() {
            if (this.board_id_from_dropmenu !== this.activeBoard['id']) {
                this.$router.push(`/project/${this.board_id_from_dropmenu}`)
                this.getTags()
                this.getBoards()
                this.$store.dispatch('setActiveBoard', this.board_id_from_dropmenu);
            }
            this.editedBoardName = this.activeBoard && this.activeBoard.title
            this.$refs['edit-board'].showModal()
        },
        goToMembers() {
            if ((this.$route.name == 'Members' && this.board_id_from_dropmenu !== this.activeBoard['id']) ||
                (this.$route.name !== 'Members' && this.board_id_from_dropmenu == this.activeBoard['id']) ||
                (this.$route.name !== 'Members' && this.board_id_from_dropmenu !== this.activeBoard['id'])
            ) {
                this.$store.dispatch('setActiveBoard', this.board_id_from_dropmenu);
                this.$router.push(`/members/${this.board_id_from_dropmenu}`)
                this.getTags()
                this.getBoards()
            }
        },
        goToAPIKeys() {
            if ((this.$route.name == 'APIKeys' && this.board_id_from_dropmenu !== this.activeBoard['id']) ||
                (this.$route.name !== 'APIKeys' && this.board_id_from_dropmenu == this.activeBoard['id']) ||
                (this.$route.name !== 'APIKeys' && this.board_id_from_dropmenu !== this.activeBoard['id'])
            ) {
                this.$store.dispatch('setActiveBoard', this.board_id_from_dropmenu);
                this.$router.push(`/api-keys/${this.board_id_from_dropmenu}`)
                this.getTags()
                this.getBoards()
            }
        },
        getBoards() {
            const board = this.boards?.length && this.boards.filter(item => item.id == this.activeBoard['id'])
            this.editedBoardName = board?.length ? board[0]?.title : ''

            const allUsers = this.boards.flatMap(board => board.members)
            const seen = {};
            const result = [];

            for (const obj of allUsers) {
                const key = obj['id'];

                if (!seen[key]) {
                    seen[key] = true;
                    result.push(obj);
                }
            }

            this.smartListUsers = result
            this.setFilterSmartUsers()
            this.smartListUsersEXCLUDEME = this.smartListUsers.filter(item => item?.id !== this.currentUser?.id)
        },
        async goToBoard(board) {
            if(this.activeBoard?.id == board.id && this.$route.name == 'Project') return
            
            this.$store.dispatch('setActiveBoard', board.id);
            this.$store.dispatch('setActiveBoardTasks', [])
            this.$store.dispatch('resetTemplateTask');
            if (`/project/${board.id}` === this.$route.path) {
                return
            } else {
                this.$router.push(`/project/${board.id}`).catch(e => {})
                this.$nextTick(() => {
                    this.getTags()
                    this.editedBoardName = this.activeBoard.title
                    this.$store.dispatch('setUserFilter', 'no-filter')
                    this.$store.dispatch('setSmartListFilter', 'no-filter')
                    this.activeIndex = null
                })
            }
        },
        async deleteBoard() {
            try {
                const data = {
                    id: this.board_id_from_dropmenu
                }
                await api.post(`/project_delete`, data);
                window.location.href = `/app`

            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || "Couldn't delete board")
            }
        },
        openNewBoard() {
            this.$refs['new-board'].showModal()
            this.board = {title: ""};
        },
        async createBoard() {
            if (this.board?.title.trim() == '') {
                this.$refs.show.showFlashError("Empty Input");
                return
            }

            const data = {
                title: this.board?.title,
                clone_from_project: Number(this.currentProjectCreatingId),
                clone_tasks: this.clone_tasks,
                members: []
            };

            if (this.newProjectMembers.length > 0) data.members = this.newProjectMembers.map(member => member.id).filter(id => id)
            data.members.unshift(this.currentUser.id)
            this.creatingNewProject = true
            try {
                let response = await api.post('/project_clone', data);

                if (response.status === 200) {
                    this.cloningProject = false;
                    this.clone_tasks = true;
                    this.$refs['new-board'].hideModal()
                    location.href = `/app/project/${response.data.data.id}`
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg || 'Something went wrong');
                this.creatingNewProject = false
                if(e.response.status === 402) {
                    this.$store.dispatch('updatePlanLimit', 'creating projects');
                }
            }
        },
        getTags() {
            if (this.activeBoard?.id && ((this.$route.name == 'Project' || this.$route.name == 'TaskModal'))) {
                this.userTags = this.activeBoard?.members;
                this.setFilterTags()
                this.setFilterUserTags()
            } else if (this.activeBoard?.id && (this.$route.name == 'SmartList' || this.$route.name == 'Activities')) {
                this.userTags = this.users
                this.setFilterSmartTags()
                this.setFilterSmartUsers()
            }
        },
        setFilterTags(item) {
            if(item) {
                this.visibleTags = this.tags.filter(tag => tag.id == item)
            } else {
                this.visibleTags = [];
            }
            
            this.dropdownTags = this.tags;
        },
        setFilterSmartTags(list) {
            if(list?.length > 0) {
                this.visibleTags = this.tags.filter(tag => list.includes(tag.id))
            } else {
                this.visibleTags = [];
            }
            
            this.dropdownTags = this.tags;
        },
        setFilterUserTags(item) {
            this.userTags = this.prioritizeMyUserTag(this.userTags, this.currentUser)
            
            if(item) {
                this.visibleUserTags = this.userTags.filter(tag => tag.id == item)
            } else {
                this.visibleUserTags = [];
            }

            this.dropdownUserTags = this.userTags;
        },
        setFilterSmartUsers(item) {
            this.userTags = this.prioritizeMyUserTag(this.userTags, this.currentUser)
            
            if(item) {
                this.visibleUsers = this.userTags.filter(tag => tag.id == item)
            } else {
                this.visibleUsers = [];
            }

            if(this.activitiesSelectedBoard) {
                this.dropdownUsers = this.activitiesSelectedBoard.members
            } else {
                this.dropdownUsers = this.userTags;
            }
        },
        prioritizeMyUserTag(array, userObj) {
            const index = array.findIndex(obj => obj?.id === userObj?.id);

            if (index !== -1) {
                const [removedObject] = array.splice(index, 1);
                array.unshift(removedObject);
            }

            return array;
        },
        async editProject(data) {
            data.id = this.activeBoard['id']
            
            try {
                const response = await api.post("/project_edit", data);
                if (response.status === 200) {
                    this.boardOverviewFunc()
                    this.$refs.show.showFlashSuccess("Project updated successfully!");
                    this.activeBoard.title = this.editedBoardName
                    if (data?.color) {
                        this.$store.dispatch('setBackgroundColor', data.color)
                        this.$forceUpdate()
                        return
                    }
                    this.$refs['edit-board'].hideModal()
                }
            } catch (e) {
                if(e.response.data.msg == 'No Access') {
                    this.$refs.show.showFlashError(e.response.data.msg);
                } else {
                    this.$refs.show.showFlashError(e.response.data.msg || 'Something went wrong');
                    this.$refs['edit-board'].hideModal()
                    console.error(e);
                }
            }
        },
        hideNavbarFunc(val) {
            this.hideNavbar = val
            this.navbarHidden = this.hideNavbar
            
            if (this.hideNavbar) {
                localStorage.setItem('hideNavbar', 'true')
                document.querySelector('.page-content-container').classList.remove('nav-shown-mode')
            } else {
                localStorage.setItem('hideNavbar', 'false')
                document.querySelector('.page-content-container').classList.add('nav-shown-mode')
            }

            this.showBoardsPopup = false
            this.showHiddenNav = false
        },
        changeTheme(val) {
            const prefix = "theme-";
            const classes = document.body.className.split(" ").filter(c => !c.startsWith(prefix));
            document.body.className = classes.join(" ").trim();

            document.body.classList.add(val)
            localStorage.setItem('theme', val.replace('theme-', ''))
            this.$store.dispatch('setTheme', val)
        },
        currentRouteTitle() {
            if (this.$route.name == 'Project' && this.activeBoard?.title) {
                return this.activeBoard?.title
            } else if (this.$route.name == 'SmartList') {
                return '<span class="sidemenu-purple-title">Smart Board</span>'
            } else if (this.$route.name == 'Activities') {
                return '<span class="sidemenu-yellow-title">Activities</span>'
            } else if (this.$route.name === 'TimeTable') {
                return '<span class="sidemenu-green-title">Time</span'
            } else if (this.$route.name == 'APIKeys') {
                return '<span class="sidemenu-light-green-title">API Keys</span>'
            } else if (this.$route.name === 'Members' && this.activeBoard?.title) {
                return `<span class="sidemenu-lightblue-title">Members</span> ${this.activeBoard?.title}`
            } else if (this.$route.name === 'Billing') {
                return '<span class="sidemenu-orange-title">Billing</span>'
            } else {
                return 'Goleko.com'
            }
        },
        async switchWithTop(board) {
            try {
                const newBoards = [...this.boards]
                let findClickItemIndex = newBoards.findIndex(item => item.id == board.id)
                newBoards.splice(findClickItemIndex, 1, newBoards.splice(findClickItemIndex - 1, 1, newBoards[findClickItemIndex])[0]);
                const newBoardsOrderIds = newBoards.map(board => board.id).join(',')
                let response = await api.post('/user_edit', {id: this.currentUser.id, project_order: newBoardsOrderIds})
                if(response.data.msg == 'ok') {
                    localStorage.setItem('currentUser', JSON.stringify(response.data.data))
                    this.$store.dispatch('setCurrentUser', response.data.data);
                    this.$store.dispatch('setBoards', newBoards);
                }
            } catch(e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || "Can't swap")
            }
        },
        async switchWithBottom(board) {
            try {
                const newBoards = [...this.boards]
                let findClickItemIndex = newBoards.findIndex(item => item.id == board.id)
                if (findClickItemIndex !== -1 && findClickItemIndex < newBoards.length - 1) {
                    newBoards.splice(findClickItemIndex, 1, newBoards.splice(findClickItemIndex + 1, 1, newBoards[findClickItemIndex])[0]);
                } else {
                    newBoards.splice(findClickItemIndex, 1, newBoards.splice(0, 1, newBoards[findClickItemIndex])[0]);
                }
                const newBoardsOrderIds = newBoards.map(board => board.id).join(',')
                let response = await api.post('/user_edit', {id: this.currentUser.id, project_order: newBoardsOrderIds})
                if(response.data.msg == 'ok') {
                    localStorage.setItem('currentUser', JSON.stringify(response.data.data))
                    this.$store.dispatch('setCurrentUser', response.data.data);
                    this.$store.dispatch('setBoards', newBoards);
                }
            } catch(e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || "Can't swap")
            }
        },
        newProjectModalHidden() {
            this.newProjectStep = 1
            this.currentProjectCreating = 'To Do List'
        },
        chooseProjectType(type, cloningExisting) {
            this.newProjectStep = 2
            this.currentProjectCreating = cloningExisting ? `Cloning ${type.title}` : type.title
            this.currentProjectCreatingId = type?.id
            this.cloningProject = !!cloningExisting
            this.$nextTick(() => this.$refs.createProjectTitleRef.$el.querySelector('input').focus())
        },
        clearTagSearch() {
            setTimeout(() => {
                this.searchUser = ''
                this.isTagInputFocused = false
            }, 250)
        },
        onResize() {
            this.windowWidth = window.innerWidth;
            // this.setFilterTags()
            // this.setFilterUserTags()
            // this.setFilterSmartUsers();
        },
        onTagsPlusClick() {
            this.isTagInputFocused = !this.isTagInputFocused;
            setTimeout(() => {
                this.$refs.searchInput?.focus();
            }, 100);
        },
        async openEmailNotifsModal() {
            this.$refs['email-notifs'].showModal()
            this.loadingEmailNotifs = true
            try {
                const response = await api.post('/user_notifs', {paginate_by: 1000})
                if (response.data.msg == 'ok') {
                    const updatedArray = response.data.data.map(obj1 => {
                        const matchingProject = this.boards.find(obj2 => obj2.id === obj1.project_id);
                        if (matchingProject) {
                            return { ...obj1, title: matchingProject.title };
                        }
                        return obj1;
                    });

                    this.emailNotifs = updatedArray
                    this.loadingEmailNotifs = false
                }
            } catch(e) {
                this.loadingEmailNotifs = false
                this.$refs.show.showFlashError(e.response?.data?.msg || 'Something went wrong!')
            }
        },
        async selectEmailNotifsOption(project, value, variable) {
            const data = {
                [variable]: value,
                project_id: project.project_id
            }
            try {
                await api.post('/user_notif_edit', data)
            } catch (e) {
                this.$refs.show.showFlashError(e.response?.data?.msg || 'Something went wrong!')
                this.$refs['email-notifs'].hideModal()
            }
        },
        setDropdownVisible(val) {
            this.isDropdownVisible = val
        },
        setAvatarDropdownVisible(val) {
            this.isAvatarDropdownVisible = val
        },
        setSmartAvatarDropdownVisible(val) {
            this.isSmartAvatarDropdownVisible = val
        },
        logOut() {
            localStorage.clear();
            location.href = '/app/login'
        },
        importCSV(e) {
            let file = e.target.files[0];

			let reader = new FileReader();
			reader.onload = () => {
                this.$store.dispatch('setImportCSV', reader.result)
                e.target.value = null
			};
			reader.readAsBinaryString(file);
        },
        async downloadExample() {
            let date = new Date()
            let formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`;
            let csv_title = `username;created_at;task_title;task_body;list_title;minutes\r\n`
            let csv_body = this.dropdownUsers.map(user => {
                return `${user.username};${formattedDate};Task title;Task body;List title;60`
            }).join('\r\n')

            let blob = new Blob([csv_title + csv_body], {type: "octet/stream"})
			let link = document.createElement("a");
			link.setAttribute("href", window.URL.createObjectURL(blob));
			link.setAttribute("download", "tasks_example.csv");
			document.body.appendChild(link);
			link.click();
        }
    },
    mounted() {
        this.$nextTick(async () => {
            if (!this.updateNavbarFlag && this.activeBoard && this.activeBoard['id'] !== null && this.boards !== null) {
                this.sidemenu_board_id = this.activeBoard['id']
                this.updateNavbarFlag = true;
                this.clonableProjects = this.boards.filter(board => board.yourPerms.includes('admin'))
                this.getTags()
                this.getBoards()

                this.board_id_from_dropmenu = this.sidemenu_board_id
            } else {
               this.updateNavbarFlag = false;
            }
            
            // Check navbar mode
            const hideNavbarLS = JSON.parse(localStorage.getItem('hideNavbar')) || false
            this.hideNavbar = hideNavbarLS
            this.navbarHidden = hideNavbarLS

            window.addEventListener('resize', this.onResize);
        })

        window.addEventListener('click', (e) => {
            this.showBoardDropmenuOptions = false
            if (e.target.classList?.contains('side-menu') || this.$refs.menu?.contains(e.target)) {
                if(e.target.closest('a.hide-menu-link')) {
                    this.showBoardsPopup = false
                    this.showHiddenNav = false

                    // document.body.querySelectorAll('.dropmenu-holder').forEach(item => {
                    //     item.classList.remove('show')
                    // })
                }
            } else {
                if (e.target.classList?.contains('alone-board-icon') || this.$refs.aloneBtn?.contains(e.target)) return

                this.showBoardsPopup = false
                this.showHiddenNav = false

                // document.body.querySelectorAll('.side-menu .dropmenu-holder').forEach(item => {
                //     item.classList.remove('show')
                // })
            }
        })

        window.addEventListener('keydown', e => {
            if (e.key == 'Escape' && this.showBoardsPopup) this.showBoardsPopup = false
            if (e.key == 'Escape' && this.isAvatarDropdownVisible) this.isAvatarDropdownVisible = false
            if (e.key == 'Escape' && this.isDropdownVisible) this.isDropdownVisible = false
            if (e.key == 'Escape' && this.isSmartAvatarDropdownVisible) this.isSmartAvatarDropdownVisible = false
        })

        window.addEventListener('beforeunload', () => localStorage.removeItem('recordingTaskID'))

        // Provoke error for testing
		this.$nextTick(() => {
			if (location?.hash && location?.hash == '#error') {
				throw new Error('Error test')
			}
		})
    },
    watch: {
        boards() {
            if (!this.updateNavbarFlag && this.activeBoard && this.activeBoard['id'] !== null && this.boards !== null) {
                this.updateNavbarFlag = true;
                this.clonableProjects = this.boards.filter(board => board.yourPerms.includes('admin'))
                //this.getTags() //removed this to fix bug with disapearing selected tags in filter after moving lists
                this.getBoards()
            } else {
               this.updateNavbarFlag = false;
            }
        },
        board_id() {
            if (!this.updateNavbarFlag && this.activeBoard['id'] !== null && this.boards !== null) {
                this.updateNavbarFlag = true;
                this.clonableProjects = this.boards.filter(board => board.yourPerms.includes('admin'))
                this.getTags()
                this.getBoards()
            } else {
               this.updateNavbarFlag = false;
            }
        },
        activeBoard(n) {
            if (n) this.getTags()
        },
        $route(){
            this.showBoardsPopup = false

            this.$store.dispatch('setUserFilter', 'no-filter')
            this.$store.dispatch('setSmartListFilter', 'no-filter')
            this.$store.dispatch('setTagFilter', 'no-filter')
            this.$store.dispatch('setSmartListTagFilter', ['no-filter'])
            this.activeIndex = null
            this.$store.dispatch('setActivitiesSelectedBoard', null)

            this.currentRouteTitle()
            this.getTags()
        },
        tags() {
            this.getTags()
        },
        activitiesSelectedBoard() {
            if(this.$route.name == 'Activities') {
                this.setFilterSmartUsers()
            }
        }
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize);
    },
};
</script>

<style lang="scss">
.side-menu {
    border-bottom: 1px solid #404040;
    padding: 10px;
    line-height: 1;
    width: 100%;
    height: auto;
    position: relative;
    z-index: 10;
    transition: 150ms ease-in-out transform;

    img {
        user-select: none;
    }

    &.navbar-hidden {
        position: absolute;
        top: 0;
        transform: translateY(-100%);

        &.show-hidden-nav {
            transform: translateY(0);
            background: linear-gradient(180deg, #122631 0%, #132935 100%);
        }
    }

    .side-menu-divider {
        border-bottom: 1px solid var(--outline);
        padding: 10px;
    }

    .sidemenu-content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .show-info-btn-wrapper {
            width: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
            background: var(--secondary-bg);
            backdrop-filter: blur(6px);
            padding: 6px 10px;
            cursor: pointer;

            i {
                font-size: 23px;
                margin-left: 5px;
            }
        }

        .sidemenu-items {
            display: flex;
            align-items: center;
            gap: 10px;
            width: 100%;
            min-height: 38px;
            user-select: none;
            
            .sidemenu-item {

                .nav-board-icon {
                    width: 30px;
                    height: 30px;
                    display: block;
                    padding-top: 4px;
                    padding-left: 4px;
                }

                .board-popup-container {
                    position: absolute;
                    top: 65px;
                    width: 100%;
                    max-width: 400px;
                    z-index: 1;
                    padding: 10px;
                    border-radius: 10px;
                    border: 0.5px solid var(--outline);
                    background: var(--primary-bg);
                    backdrop-filter: blur(6px);

                    .board-popup-inner {
                        border-radius: 5px;
                        color: #fff;

                        .board-popup-header {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 10px;

                            .board-popup-title {
                                padding: 0;
                            }

                            .checkbox-toggle {
                                margin-top: 0;
                            }
                        }

                        .board-popup-title {
                            padding: 10px;
                        }

                        .boards-container {
                            border-top: 1px solid var(--outline);
                            border-bottom: 1px solid var(--outline);
                            padding: 10px;

                            .board-items {
                                max-height: 300px;
                                overflow-x: hidden;
                                overflow-y: auto;
                                padding-right: 10px;

                                .board-item {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    color: var(--primary-text);
                                    font-size: 18px;
                                    font-weight: 500;
                                    padding: 5px;
                                    border-radius: 5px;
                                    cursor: pointer;
                                    position: relative;
                                    transition: 150ms ease-in-out background-color, 150ms ease-in-out color;
                                    
                                    &:hover {
                                        background-color: var(--hover);
                                        color: var(--primary-text);
                                    }

                                    &.board-item-active {
                                        background-color: var(--accent);
                                        color: #fff;
                                        .icon-dots-horizontal-triple:before {
                                            color: #fff;
                                        }
                                        .board-item-notif {
                                            color: var(--primary-text);
                                        }
                                    }


                                    .board-item-funcs {
                                        display: flex;
                                        align-items: center;
                                        gap: 5px;

                                        .dropmenu-holder .btn {
                                            background-color: transparent;
                                            padding: 2px;
                                        }
                                    }

                                }
                            }
                            .board-item-notif {
                                width: 18px;
                                height: 18px;
                                text-align: center;
                                font-size: 12px;
                                font-weight: 600;
                                background-color: var(--hover);
                                border-radius: 50%;
                                padding-top: 3px;
                            }

                            .switch-board-btn {
                                font-size: 8px;
                                height: 100%;
                                aspect-ratio: 1;
                                padding: 1px 6px;
                                border-radius: 5px;
                            }

                            .add-board {
                                display: block;
                                text-align: center;
                                padding: 5px;
                                margin-top: 5px;

                                &:hover {
                                    .icon-add:before {
                                        color: var(--accent);
                                    }
                                }
                            }
                        }

                        .apps-container {
                            display: grid;
                            grid-template-columns: repeat(5, 1fr);
                            gap: 10px;
                            text-align: center;
                            padding: 10px;
                            isolation: isolate;

                            .app-item {
                                img {
                                    width: 2.8125rem;
                                }
                                p {
                                    margin: 5px 0 0;
                                    font-size: 13px;
                                }
                            }
                        }
                    }

                    .hideModalRef {
                        margin-top: 10px;
                        width: 100%;
                        display: flex;
                        justify-content: flex-end;
                    }
                }

                &.filters-container {
                    display: flex;
                    gap: 7px;
                    flex-wrap: wrap;
                    align-content: center;
                    align-items: center;
                    position: relative;

                    .toggle-dropdown {
                        position: relative;
                    }

                    .tag-item {
                        .not-assigned-task {
                            border: 1.5px solid #73737359;
                            font-size: 12px;
                        }
                        .user-tag {
                            width: 38px;
                            height: 38px;
                            border-radius: 50% !important;
                            background: var(--primary-bg);
                            color: #fff;
                            cursor: pointer;
                            padding: 0;
                            overflow: hidden;
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            &:hover, &.active-member-filter {
                                border: none;
                                color: #fff;
                                outline: 4px solid #9BDBFF;
                            }

                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }

                        .tooltip > * { min-width: 120px; }
                    }
                }
            }

            .smart-list-users {
                position: relative;
            }
            input.textfield {
                margin-bottom: 0 !important;
                border: none;
            }
            .divide {
                border-radius: 1px;
                background: #FFF;
                width: 1px;
                height: 25px;
            }
            .user-filter {
                font-size: 18px;
                font-weight: 500;
                color: #fff;
            }
        }
        .board-title {
            color: #fff;
            display: flex;
            align-items: center;
            gap: 10px;
            
            h3 {
                margin-bottom: 0;

                .sidemenu-green-title {
                    color: #6BC754;
                }

                .sidemenu-light-green-title {
                    color: #CAE236;
                }

                .sidemenu-lightblue-title {
                    color: #9BDBFF;
                }

                .sidemenu-purple-title {
                    color: #BB9BFF;
                }

                .sidemenu-orange-title {
                    color: #FF8A00;
                }

                .sidemenu-yellow-title {
                    color: #FFD652;
                }
            }
        }
    }

}

.side-menu-container {
    .edit-board {
        .modal {
            overflow-y: visible;
            overflow-x: visible;
        }
        .edit-board-head {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 17px;

            .portrait-container {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                overflow: hidden;
                border: none;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .initial {
                    font-size: 24px;
                    font-weight: 600;
                    margin-bottom: 0;
                }
            }
            .in-progress {
                margin-top: 14px;
            }
        }
        .edit-board-body {
            .btn {
                width: 64px;
                margin-right: 5px;
            }
            .color-selector {
                margin-bottom: 5px; 
            }
            h3 {
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 5px;
            }
        }
    } 
    .delete-btn-wrap {
        margin-top: 34px;
        display: flex;
        justify-content: flex-end;
    }
    .pfp-uploader {
        margin: 20px 0;
        .pfp-input {
            display: none;
        }
    }

    .dropdown {
        .member-wrap {
            display: flex;
            align-items: center;
            gap: 10px;
            margin: 10px 0;
            border-radius: 6px;
            padding: 3px;
            
        }

        .tag-item-wrap {
            min-height: 32px;
        }

        .tag-icon {
            font-size: 25px;
            
        }

        .tag-item {
            color: var(--primary-text);
            font-size: 14px;
            font-weight: 400;
        }

        .avatar-wrap {
            width: 28.6px;
            height: 28.6px;
            border-radius: 50%;
            background: #fff;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
                min-width: 28px;
            }
            span {
                display: flex;
                align-items: center;
                justify-content: center;
                color: black;
                width: 28.6px;
                height: 28.6px;
            }
        }
    }

    .new-project-flow-modal {
        &.step2 {
            .modal {
                overflow-y: visible;
                overflow-x: visible;
                .scroll-wrap {
                    overflow: visible;
                }
            }
        }

        p, label {
            font-size: 14px;
            color: #FFFFFFBF;
            display: block;
        }

        .modal-header h2, label {
            margin-bottom: 4px;
        }
    
        .flow-btn {
            width: 78px;
        }
        
        .new-project-textfield .textfield{
            width: 244px;
            background: inherit;
            border-radius: 10px;
            border: 0.5px solid var(--outline);
        }
        .select-selected {
            outline: none;
            background: var(--primary-bg);
            border: 0.5px solid var(--outline);
            border-radius: 10px;
            width: 244px;
            overflow: overlay;
        }

        .custom-select {
            border: none;
            width: 244px;
        }

        .custom-select .select-items {
            transform: translate(0);
            position: inherit;
            height: 197px;
            margin-top: 10px;
            outline: none;
            width: fit-content;
        }

        .flex-btwn {
            margin-top: 15px;
        }
        .members {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 10px 10px;
            margin: 10px 0;

            & span {
                margin-right: 2px;
                display: inline-block;
                vertical-align: middle;
                position: relative;
                width: 16px;
                height: 16px;
                transform: rotate(45deg);
                cursor: pointer;
            }

            & span:before, & span:after {
                content: '';
                background-color: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            & span:before {
                width: 1.5px;
                height: 10px;
            }

            & span:after {
                width: 10px;
                height: 1.5px
            }

            .member-tag {
                position: relative;
                padding: 3px;
                background-color: $blue;
                border-radius: 6px;
            }
        }
    }

    .theme-modal .modal { overflow: unset; }

    .profile-modal .modal, .billing-modal .modal { max-width: 412px; }

    .project-types {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px 25px;
        margin-bottom: 15px;

        .project-type-card {
            padding: 20px 5px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            background: var(--primary-bg);
            border: 0.5px solid var(--outline);

            &:hover {
                border: 1px solid var(--outline-active);
            }
            
            &.clone-project {
                position: relative;

                &::before {
                    content: 'Clone';
                    position: absolute;
                    top: 3px;
                    left: 6px;
                    font-size: 12px;
                    opacity: .6;
                }
            }
        }
    }

    .boardDropmenu {
        display: block;
        z-index: 10;
    }

    .email-notifs {

        .modal {
            max-width: 627px;
            max-height: 555px;
            padding: 16px 21px;
            background-color: var(--primary-bg);
            backdrop-filter: blur(6px);
        
            .bg-description {
                margin-bottom: 18px;

                p {
                    margin-bottom: 0;
                }
            }
        }

        .custom-select .select-items {
            bottom: -6px;
        }

        .email-notifs-table {
            border: 0.5px solid var(--outline);
            border-radius: 10px;
            overflow-x: auto;
            padding: 8px 0;
        }

        table {
            width: 100%;
            table-layout: fixed;

            th:first-child {
                padding-left: 10px;
            }

            th {
                border-bottom: 0.5px solid var(--outline);
                font-size: 14px;
                font-weight: 500;
                letter-spacing: -0.14px;
            }
            tr {
                padding: 0 10px;
            }

            tr:first-of-type {
                td {
                    padding-top: 10px;
                }
            }
            
            td {
                padding-bottom: 5px;
            }

            th,
            td {
                &:first-child {
                    width: 180px;
                }
            }
        }

        &__project-title {
            padding-left: 10px;
        }

        &__selector {
            position: relative;
            .icon-arrow-down-small {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 14px;
                font-size: 6px;
            }
        }


        .custom-select {
            border: none;
            .select-selected {
                outline: none;
                box-shadow: none;
            }
            .select-items {
                backdrop-filter: blur(6px);
                outline: none;
                padding: 8px 4px;
            }
        }
    }
}



.user-dont-exist-msg {
    padding-left: 6px;
    padding-right: 6px;
    margin-bottom: 0;
    color: #D8D8D8;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
}

.nav-btn {
    color: var(--accent);
    font-weight: 500;
    display: flex;
    align-items: center;
    i {
        display: block;
        display: block;
        margin-right: 2px;
        &::before {
            color: var(--accent);
        }
    }
}

.separator-dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #fff;
}

.alone-board-icon {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;

    &.hide-alone-icon {
        opacity: 0;
        pointer-events: none;
    }
}

.theme-modal .modal {
    max-width: fit-content !important;
    background: var(--primary-bg);
}

.themes-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    text-align: center;

    .theme-item {
        p {
            text-transform: capitalize;
        }
        input {
            display: none;
    
            &:checked + label { box-shadow: 0 0 10px 1px #000; }
        }
        label {
            width: 80px;
            height: 80px;
            display: inline-block;
            cursor: pointer;
            border-radius: 7px;
            border: 0.5px solid gray;
        }
    }
}
.version {
    .help-text {
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
    }
}

.bg-description {
    border-radius: 10px;
    background: rgba(36, 40, 49, 0.33);
    color: $gray-text;
    padding: 10px 13px;
    font-size: 14px;
    font-weight: 300;
    line-height: normal;
    display: block;
}

.custom-input-file {
    position: relative;
    display: block;
    cursor: pointer;

    &:hover {
        .fake-btn {
            background: var(--hover);
            color: #000;
        }
    }

    input[type="file"] {
        position: fixed;
        left: 0;
        top: 0;
        opacity: 0;
        z-index: -1;
        visibility: hidden;
    }

    .fake-btn {
        border-radius: 6px;
        display: block;
        margin-left: 0;
        padding: 6px 10px;
        line-height: 1.2;
        color: #fff;
        border: 1px solid var(--outline);
        transition: all .3s ease-in;

        i {
            margin-left: 3px;
        }
    }

    .tooltip__info {
        code {
            margin: 0;
            background-color: $gray-6;
            border-radius: 10px;
            padding: 7px;
            font-size: 14px;
        }
    }

    .connecter-part {
        left: 100%
    }
}

.new-project-flow-modal {
    label.custom-checkbox-wrap {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
    }
}
</style>
